import {mapMutations} from "vuex";

const mixin = {
    data(){
        return{
            scopes: []
        }
    },
    methods:{
        ...mapMutations({
            'setScopes' : 'profile/setScopeSaveStates'
        }),
        getSection(section){
            this.$axios.get(`/api/rest/profile/${section}`)
                .then(res => {
                    this.scopes = res.data.scopes;
                    this.setScopes(this.scopes);
                })
        }
    }
}

export default mixin